export default __webpack_public_path__ + "static/media/Capri-Pink.726b6e76.jpg";